import type { BoxSpacing, TableCell, TableElement } from '@/components/canvas/document/publicTypes';
import { type BaseElementConfig, createBase } from '../registry/factoryShared';

export function createTableElement(
  config: BaseElementConfig & {
    rows: number;
    cols: number;
    cells?: Record<string, TableCell>;
    rowHeights?: number[];
    colWidths?: number[];
    borderPreset?: TableElement['data']['borderPreset'];
    tableStyle?: TableElement['data']['tableStyle'];
    padding?: BoxSpacing;
  },
): TableElement {
  const base = createBase('table', config);
  return {
    ...base,
    size: {
      ...base.size,
      padding: config.padding,
    },
    data: {
      rows: Math.max(1, config.rows),
      cols: Math.max(1, config.cols),
      cells: config.cells,
      rowHeights: config.rowHeights,
      colWidths: config.colWidths,
      borderPreset: config.borderPreset ?? 'full',
      tableStyle: config.tableStyle ?? 'default',
    },
  };
}
